<template>
    <div class="tab-pane" id="search-tab-pane">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 py-5 text-center">
                        <h2 class="text-primary font-weight-thin mb-4">{{ __('lang.start.tab.directsearch.headtext') }}</h2>
            </div>
            <div class="col-12">
                <div class="form-row justify-content-center">
                <p class="text-center col-12">{{ __('lang.directsearch.cat.info.text') }}</p>
                    <div class="form-group col-sm-12 col-md">
                        <label class="text-primary col-form-label col-form-label-sm">{{ __('lang.directsearch.btn.op.categories.select.label')}}</label>
                        <p>
                                        <a class="btn btn-gray-50 col-md-10 mx-auto p-2" role="button" data-toggle="modal" tabindex="1"
                                        data-target="#categoryModal_directsearch" data-content="type-filter" @click="getCategories"><svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.filter" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                        </svg>
                                        {{ this.__('lang.directsearch.btn.op.categories.select') }}
                                        </a>
                                    </p>
                    </div>
                    <div class="form-group col-sm-12 col-md">
                        <label class="text-primary col-form-label col-form-label-sm">{{ __('lang.directsearch.input.label')}} </label>
                        <productsearch ref="productsearch" parentID="start"></productsearch>
                    </div>
                </div>
            </div>
        </div>

       <!--  <div class="row justify-content-center">
            <div class="col-12 col-md-8 py-5">
                <h2 class="text-primary font-weight-thin mb-5 text-center">{{
                __('lang.start.tab.directsearch') }}</h2>

                <p class="text-center">{{ __('lang.directsearch.cat.info.text') }}</p>
                <div class="form-row mb-5">
                    <div class="form-group col-8">
                        <p>
                            <a class="btn btn-gray-50 btn-block col-md-6 mx-auto" role="button" data-toggle="modal" tabindex="1"
                            data-target="#categoryModal_directsearch" data-content="type-filter" @click="getCategories">
                            <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.filter" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>{{ this.__('lang.btn.op.categories.select') }}
                            </a>
                        </p>
                    </div>
                    <div class="form-group col-4">
                        <button class="btn btn-primary btn-block" @click.prevent="set_contentnav"  tabindex="2" :disabled="state_button">
                            <svg class="icon">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.form.send"
                                xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>{{ __('lang.btn.search') }}
                      </button>
                    </div>

                </div>
                <p class="text-center">{{ __('lang.nav.productsearch.info.text') }}</p>
                <productsearch ref="productsearch" parentID="start"></productsearch>
            </div>
        </div> -->

        <div class="modal fade" id="categoryModal_directsearch" tabindex="-1" aria-hidden="true" data-backdrop="static" and
          data-keyboard="false">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content rounded-lg border-0 shadow-lg">
              <div class="modal-header justify-content-end align-items-center border-0 px-4 row">
                <div class="col-md-6 col-sm-12 text-left">
                  <a class="btn btn-sm btn-link global-select-all"  id="all_check" role="button"
                    data-global-count="0" @click.prevent="$refs.categories_directsearch.setcheckedall(true,'ds')">
                    <svg class="icon icon-xs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>{{ __('lang.btn.select_all') }}</a><a class="btn btn-sm btn-link global-deselect-all" id="all_uncheck"
                    role="button" @click.prevent="$refs.categories_directsearch.setcheckedall(false,'ds')">
                    <svg class="icon icon-xs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>{{ __('lang.btn.unselect_all') }}</a><a class="btn btn-sm btn-link global-collapse-show-all"
                    role="button" @click.prevent="$refs.categories_directsearch.setcollapseall(true)">
                    <svg class="icon icon-xs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>{{ __('lang.collapse.expandall') }}</a><a class="btn btn-sm btn-link global-collapse-hide-all"
                    role="button" @click.prevent="$refs.categories_directsearch.setcollapseall(false)">
                    <svg class="icon icon-xs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.collapse-up"
                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>{{ __('lang.collapse.collapseall') }}
                  </a>
                </div>

                <div class="col-md-6 col-sm-12 text-right">
                  <button class="btn btn-gray-50 text-white px-4 pull-right col-md-3 col-sm-12" type="reset" data-dismiss="modal"
                    @click.prevent="$refs.categories_directsearch.restoreCategories">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>{{ __('lang.btn.cancel') }}
                  </button>

                  <button class="btn btn-primary border-0 col-md-3 col-sm-12" type="button" data-dismiss="modal" aria-label="Close"
                    @click.prevent="$refs.categories_directsearch.storeCategories">
                    <svg class="icon">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg>{{ __('lang.btn.submit') }}
                  </button>
                  <button class="close m-1 d-none" type="button" id="closecategoriesModal" data-dismiss="modal"
                    aria-label="Close"><span aria-hidden="true">
                      <svg class="icon icon-xs">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                        </use>
                      </svg></span></button>
                </div>
              </div>
              <div class="modal-body">
                <categories ref="categories_directsearch" parentID="tab_ds"></categories>
              </div>
            </div>
            <!-- </div> -->

          </div>
        </div>
    </div>
</template>
<script>

import productsearch from './ProductSearch'
import categories from './Categories'
import operatingpointApi from "./services/api/operatingpointAPI";
//import operatingpointApi from './services/api/operatingpointAPI'
export default {
    components: {
        productsearch,
        categories
    },
    computed: {
       /*  state_button() {
            var cat = this.selectedcategories
            var cat_count = parseInt(Object.keys(cat).filter(key => cat[key] == true).length)

            //&& Object.keys(this.selectedcategories).filter(key => cat[key] == true).length > 1
            return !(cat_count > 0)
        }, */
        selectedcategories: {
            get() {
                return this.$store.state.operatingpoint.selectedCategories;
            },
            set() {
                commit('operatingpoint/updateselectedCategories');
            },

        },


    },
    data() {
        return {
           categories: [],
        }
    },
    methods: {
        resetInputData() {
            this.$refs.productsearch.resetInputData()
        },
        getCategories() {
            this.$refs.categories_directsearch.getCategoriesDirectsearch()
        },
       /*  set_contentnav() {
            this.$root.$refs.main.listenerchild({ nav: "3", searchflag: "cat" });
        }, */
       /*  async getCategories() {
        var body = []


        body.push({
            language_id: this.$lang().locale, //navigator.language,
            filter:0
        })
        var response = await operatingpointApi.getCategories(body);
        this.categories = response.categories;
        console.log('Tab directsearch categories');
        console.log(response.categories);


        }, */
    },
    mounted() {

        // // activate search tab and archive search when the parameter is in url
        // const queryString = window.location.search;
        // const urlParams = new URLSearchParams(queryString);
        // const searchArchiv = urlParams.get('search_archiv')
        // console.log('this.search.archive')
        //
        // if (searchArchiv && searchArchiv == '1') {
        //     let searchTab = document.getElementById('search-nav-tab')
        //     let searchTabPane = document.getElementById('search-tab-pane')
        //     let allTabPanes = document.querySelectorAll('.tab-pane')
        //     let allLinksTabs = document.querySelectorAll('.nav-tabs > .nav-item > .nav-link')
        //     let checkboxArchive = document.querySelectorAll('#search-tab-pane input#archive')
        //     let searchInputFields = document.querySelectorAll('#autosuggest__input')
        //
        //     // searchInputFields.forEach((searchInputField)=>{
        //     //     // searchInputField.value
        //     //     body.push({
        //     //         searcharchive: 'true',
        //     //     })
        //     // });
        //
        //     // let productsPromises = operatingpointApi.getFansSuggest(body)
        //
        //     allTabPanes.forEach((tabPane) => {
        //         tabPane.classList.remove('active')
        //     });
        //
        //     allLinksTabs.forEach((linkTab)=>{
        //         linkTab.classList.remove('active');
        //     })
        //
        //     checkboxArchive[1].checked=true;
        //     // checkboxArchive[1].classList.add('aaanthi')
        //     searchTab.classList.add('active');
        //     searchTabPane.classList.add('active');
        //
        // }

    }
}
</script>
